export default {
    setPricing(state, results) {
        state.pricing = results.data;
        console.log("setPricing")
    },
}